export default __webpack_public_path__ + "static/media/coin-under.3f862765.png";